export function parseDownloadLink(text: string, endTag: string) {
  const contentEnd = text.indexOf(endTag);
  const url = text.substring(0, contentEnd === -1 ? text.length : contentEnd - 1);
  const name = url.split('/').at(-1);

  const icon = `<font-awesome-icon class="text-primary" :icon="['far', 'file']" />`;
  const classLink = 'downloadlink-icon';
  const html = `<div class="mt-2"></div><a class="${classLink}" target="_blank" href="${url}">${icon}<span class="ml-2">${name || url}</span></a>`;

  return {
    html,
    consumedLength: url.length + endTag.length + 2,
  };
}
